import { SlingoLang } from "@lib/titan2-slingo/dist/game/view/abstract/lang/SlingoLang";
/**
 * GameLang.ts
 */
export class GameLang extends SlingoLang {
}
GameLang.PRE_BONUS_PROMPT = "GameLang.PRE_BONUS_PROMPT";
GameLang.BONUS = "GameLang.BONUS";
GameLang.BONUS_PROMPT2 = "GameLang.BONUS_PROMPT2";
GameLang.BONUS_PROMPT3 = "GameLang.BONUS_PROMPT3";
GameLang.BONUS_PROMPT4 = "GameLang.BONUS_PROMPT4";
GameLang.BONUS_PROMPT5 = "GameLang.BONUS_PROMPT5";
GameLang.SLINGOS = "GameLang.SLINGOS";
GameLang.BONUS_WIN_TITLE = "BonusLang.DIALOG_PAYOUT_BASE";
GameLang.BONUS_LABEL1 = "GameLang.BONUS_LABEL1";
GameLang.BONUS_LABEL2 = "GameLang.BONUS_LABEL2";
GameLang.BONUS_LABEL3 = "GameLang.BONUS_LABEL3";
GameLang.BONUS_GREEN_TITLE = "GameLang.BONUS_CUPS_TITLE";
GameLang.BONUS_RED_TITLE = "GameLang.BONUS_LADY_TITLE";
GameLang.BONUS_PURPLE_TITLE = "GameLang.BONUS_HUNGRY_TITLE";
GameLang.BONUS_GOLD_TITLE = "GameLang.BONUS_CLEO_TITLE";
GameLang.BONUS_FOOD_TITLE = "GameLang.BONUS_TOTES_TITLE";
GameLang.RESULT = "GameLang.RESULT";
GameLang.AVAILABLE_WIN_LABEL0 = "GameLang.AVAILABLE_WIN_LABEL0";
GameLang.AVAILABLE_WIN_LABEL1 = "GameLang.AVAILABLE_WIN_LABEL1";
GameLang.AVAILABLE_WIN_LABEL2 = "GameLang.AVAILABLE_WIN_LABEL2";
GameLang.COPYRIGHT = "GameLang.LEGAL_GMR";
GameLang.BIG_WIN = "GameLang.BIG_WIN";
GameLang.SUPER_BIG_WIN = "GameLang.SUPER_BIG_WIN";
GameLang.MEGA_WIN = "GameLang.MEGA_WIN";
GameLang.BIG_WIN_0 = "GameLang.BIG_WIN_0";
GameLang.HUGE_WIN_0 = "GameLang.HUGE_WIN_0";
GameLang.MEGA_WIN_0 = "GameLang.MEGA_WIN_0";
GameLang.BIG_WIN_1 = "GameLang.BIG_WIN_1";
// /////////////////////
// ///Parameter names
GameLang.PARAM_GAME = "{param.game}";
GameLang.PARAM_FEATURE_MULTIPLIER = "{param.feature.multiplier}";
GameLang.CASH_BONUS = "{param.ladder.cash}";
GameLang.X_CASH = "{param.ladder.current.multiplier}";
GameLang.PARAM_SPINS = "{param.ladder.spins}";
GameLang.CURRENCY = "{currency}";
GameLang.LOADER_GUIDE_BODY_0 = "GameLang.LOADER_GUIDE_BODY_0";
GameLang.LOADER_GUIDE_BODY_1 = "GameLang.LOADER_GUIDE_BODY_1";
GameLang.LOADER_GUIDE_BODY_2 = "GameLang.LOADER_GUIDE_BODY_2";
GameLang.LOADER_GUIDE_BODY_3_2 = "GameLang.LOADER_GUIDE_BODY_3_2";
GameLang.LOADER_GUIDE_BODY_3_1 = "GameLang.LOADER_GUIDE_BODY_3_1";
GameLang.LOADER_GUIDE_BODY_3_0 = "GameLang.LOADER_GUIDE_BODY_3_0";
GameLang.LEGAL_3P = "GameLang.LEGAL_3P";
GameLang.LEGAL_GMR = "GameLang.LEGAL_GMR";
GameLang.SLINGO_1 = "GameLang.SLINGO_1";
GameLang.SLINGO_2 = "GameLang.SLINGO_2";
GameLang.SLINGO_3 = "GameLang.SLINGO_3";
GameLang.SLINGO_4 = "GameLang.SLINGO_4";
GameLang.SLINGO_5 = "GameLang.SLINGO_5";
GameLang.SLINGO_6 = "GameLang.SLINGO_6";
GameLang.SLINGO_7 = "GameLang.SLINGO_7";
GameLang.SLINGO_8 = "GameLang.SLINGO_8";
GameLang.SLINGO_9 = "GameLang.SLINGO_9";
GameLang.SLINGO_10 = "GameLang.SLINGO_10";
GameLang.SLINGO_12 = "GameLang.SLINGO_12";
GameLang.SLINGO_12_1 = "GameLang.SLINGO_12_1";
GameLang.SLINGO_12_2 = "GameLang.SLINGO_12_2";
GameLang.SLINGO_SHORT_1 = "GameLang.SLINGO_SHORT_1";
GameLang.SLINGO_SHORT_2 = "GameLang.SLINGO_SHORT_2";
GameLang.SLINGO_SHORT_3 = "GameLang.SLINGO_SHORT_3";
GameLang.SLINGO_SHORT_4 = "GameLang.SLINGO_SHORT_4";
GameLang.SLINGO_SHORT_5 = "GameLang.SLINGO_SHORT_5";
GameLang.SLINGO_SHORT_6 = "GameLang.SLINGO_SHORT_6";
GameLang.SLINGO_SHORT_7 = "GameLang.SLINGO_SHORT_7";
GameLang.SLINGO_SHORT_8 = "GameLang.SLINGO_SHORT_8";
GameLang.SLINGO_SHORT_9 = "GameLang.SLINGO_SHORT_9";
GameLang.SLINGO_SHORT_10 = "GameLang.SLINGO_SHORT_10";
GameLang.SLINGO_SHORT_12 = "GameLang.SLINGO_SHORT_12";
GameLang.SLINGO_LADDER_AWARD_SPINS = "GameLang.SLINGO_LADDER_AWARD_SPINS";
GameLang.SLINGO_LADDER_AWARD_FREE_SPINS = "GameLang.SLINGO_LADDER_AWARD_FREE_SPINS";
GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_CURRENT = "GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_CURRENT";
GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_WHEEL = "GameLang.SLINGO_LADDER_AWARD_MULTIPLIER_WHEEL";
GameLang.IDLE_0 = "GameLang.IDLE_0";
GameLang.IDLE_1 = "GameLang.IDLE_1";
GameLang.IDLE_2 = "GameLang.IDLE_2";
GameLang.IDLE_3 = "GameLang.IDLE_3";
GameLang.IDLE_4 = "GameLang.IDLE_4";
GameLang.IDLE_5 = "GameLang.IDLE_5";
GameLang.IDLE_6 = "GameLang.IDLE_6";
GameLang.IDLE_7 = "GameLang.IDLE_7";
GameLang.IDLE_8 = "GameLang.IDLE_8";
GameLang.PURCHASE_SPIN_0 = "GameLang.PURCHASE_SPIN_0";
GameLang.PURCHASE_SPIN_1 = "GameLang.PURCHASE_SPIN_1";
GameLang.PURCHASE_SPIN_2 = "GameLang.PURCHASE_SPIN_2";
GameLang.PURCHASE_SPIN_3 = "GameLang.PURCHASE_SPIN_3";
GameLang.PURCHASE_SPIN_4 = "GameLang.PURCHASE_SPIN_4";
GameLang.PURCHASE_SPIN_5 = "GameLang.PURCHASE_SPIN_5";
GameLang.PURCHASE_SPIN_6 = "GameLang.PURCHASE_SPIN_6";
GameLang.AVAILABLE_WIN_0 = "GameLang.AVAILABLE_WIN_0";
GameLang.AVAILABLE_WIN_1 = "GameLang.AVAILABLE_WIN_1";
GameLang.AVAILABLE_WIN_2 = "GameLang.AVAILABLE_WIN_2";
GameLang.AVAILABLE_WIN_PLUS = "GameLang.AVAILABLE_WIN_PLUS";
GameLang.COLLECT_BUTTON_WIN_0 = "GameLang.COLLECT_BUTTON_WIN_0";
GameLang.COLLECT_BUTTON_WIN_1 = "GameLang.COLLECT_BUTTON_WIN_1";
GameLang.COLLECT_BUTTON_WIN_2 = "GameLang.COLLECT_BUTTON_WIN_2";
GameLang.WIN_0 = "GameLang.WIN_0";
GameLang.WIN_1 = "GameLang.WIN_1";
GameLang.WIN_2 = "GameLang.WIN_2";
GameLang.WIN_3 = "GameLang.WIN_3";
GameLang.FEATURE_CELL = "GameLang.FEATURE_CELL";
GameLang.INSTANT_CELL = "GameLang.INSTANT_CELL";
GameLang.FREE_SPINS = "GameLang.FREE_SPINS";
GameLang.SPINS = "GameLang.SPINS";
GameLang.RESULT_SCATTER = "GameLang.RESULT_SCATTER";
GameLang.RESULT_INSTANT = "GameLang.RESULT_INSTANT";
GameLang.BONUS_PROMPT1 = "GameLang.BONUS_PROMPT1";
GameLang.BONUS_0_TITLE = "GameLang.BONUS_0_TITLE";
GameLang.BONUS_0_LINE = "GameLang.BONUS_0_LINE";
GameLang.BONUS_0_PROMPT1 = "GameLang.BONUS_0_PROMPT1";
GameLang.BONUS_1_TITLE = "GameLang.BONUS_1_TITLE";
GameLang.BONUS_1_LINE = "GameLang.BONUS_1_LINE";
GameLang.BONUS_1_PROMPT1 = "GameLang.BONUS_1_PROMPT1";
GameLang.BONUS_2_TITLE = "GameLang.BONUS_2_TITLE";
GameLang.BONUS_2_LINE = "GameLang.BONUS_2_LINE";
GameLang.BONUS_2_PROMPT1 = "GameLang.BONUS_2_PROMPT1";
GameLang.BONUS_3_TITLE = "GameLang.BONUS_3_TITLE";
GameLang.BONUS_3_LINE = "GameLang.BONUS_3_LINE";
GameLang.BONUS_3_PROMPT1 = "GameLang.BONUS_3_PROMPT1";
GameLang.BONUS_4_TITLE = "GameLang.BONUS_4_TITLE";
GameLang.BONUS_4_LINE = "GameLang.BONUS_4_LINE";
GameLang.BONUS_4_PROMPT1 = "GameLang.BONUS_4_PROMPT1";
GameLang.BONUS_4_PROMPT2 = "GameLang.BONUS_4_PROMPT2";
GameLang.BONUS_GREEN_LINE = "GameLang.BONUS_CUPS_LINE";
GameLang.BONUS_RED_LINE = "GameLang.BONUS_LADY_LINE";
GameLang.BONUS_PURPLE_LINE = "GameLang.BONUS_HUNGRY_LINE";
GameLang.BONUS_GOLD_LINE = "GameLang.BONUS_CLEO_LINE";
GameLang.BONUS_FOOD_LINE = "GameLang.BONUS_TOTES_LINE";
//# sourceMappingURL=GameLang.js.map